import React, { useEffect } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { fetchClinicDropdown } from "services/doctorClinicRouter";

const ClinicDropdown = ({
  errors,
  control,
  setValue,
  watch,
  required,
  defaultValue,
}) => {
  const selectedClinic = watch("clinic_id");

  const {
    data: clinics,
    isLoading,
    error,
  } = useQuery(["clinic-dropdown"], fetchClinicDropdown, {
    staleTime: DROPDOWN_STALE_TIME,
  });

  useEffect(() => {
    if (defaultValue) {
      setValue("clinic_id", defaultValue);
    }
  }, [defaultValue, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading clinics</div>;

  const options =
    clinics?.data?.map((clinic) => ({
      value: clinic.id,
      label: clinic.clinic_name,
    })) || [];

  const selectedOption =
    options.find((option) => option.value === selectedClinic) ||
    options.find((option) => option.value === defaultValue) ||
    null;

  return (
    <Controller
      name="clinic_id"
      control={control}
      rules={{
        required: required ? "Clinic is required" : false,
      }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption}
          placeholder="Select Clinic"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("clinic_id", value);
          }}
          className={`react-select-container ${
            errors?.clinic_id ? "is-invalid" : ""
          }`}
        />
      )}
    />
  );
};

export default ClinicDropdown;
